import type { RolesResponse } from "@/interfaces/roles";
import { apiClient } from "@/lib/apiClient";

export async function fetchRoles(): Promise<RolesResponse> {
  const { data } = await apiClient.get<RolesResponse>("/me/roles");
  return data;
}
